(function (angular, app) {
   "use strict";
   
   // UIFactory
   angular.module(app.modules.ui.name)
      .factory(app.modules.ui.services.ui, UIFactory);
   
   // Injector
   UIFactory.$inject = ["ngDialog", "$window"
   , app.modules.common.services.eventbus
   , app.modules.common.services.functions
   , app.modules.common.constants.appsettings
   ];
   
   // Function
   function UIFactory(ngDialog, $window, ggCoreSvc, ggFunctions, appSettings) {

      //##//--------------------------------------- 
      
      // Modals // Put the modals in the service so the can be called from multiple controllers.
      var modal = {
         close : function(){
            ngDialog.closeAll();
         }
         , open : {
            login : function(data){
               ngDialog.closeAll();

               app.Member.Session.pageTemplates.fetch(app.modules.ui.templates.login.templateId).then(function (template) {
                  if (isCordova && isCordovaReady) {
                     StatusBar.backgroundColorByHexString(app.Branding.hexModal);
                  }

                  var _loginDialog = ngDialog.open({
                     template: template
                     , plain: true
                     , closeByEscape: true
                     , closeByDocument: false
                     , className: "login"
                     , trapFocus: false
                     , data: data
                  });
                  _loginDialog.closePromise.then(function () {
                     if (isCordova && isCordovaReady) {
                        StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                     }
                  });
               });

            }
            , password : function(){
               ngDialog.closeAll();
               app.Member.Session.pageTemplates.fetch(app.modules.ui.templates.password.templateId).then(function (template) {
                  if (isCordova) {
                     StatusBar.backgroundColorByHexString(app.Branding.hexModal);
                  }

                  var _passwordDialog = ngDialog.open({
                     template: template
                     , plain: true
                     , closeByEscape: true
                     , closeByDocument: false
                     , className: "login"
                     , trapFocus: false
                  });

                  _passwordDialog.closePromise.then(function () {
                     if (isCordova) {
                        StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                     }
                  });
               });
            }
            , coursehandicap : function(){
               ngDialog.closeAll();

               app.Member.Session.pageTemplates.fetch(app.modules.ui.templates.courseHandicap.templateId).then(function (template) {
                  if (isCordova) {
                     StatusBar.backgroundColorByHexString(app.Branding.hexModal);
                  }

                  var _handicapDialog = ngDialog.open({
                     template: template
                     , plain: true
                     , closeByEscape: true
                     , closeByDocument: false
                     , className: "fullscreen slideup"
                     , trapFocus : false
                  });

                  _handicapDialog.closePromise.then(function () {
                     if (isCordova) {
                        StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                     }
                  });
               });

            }
            , checkout: function (data) {
               ngDialog.closeAll();

               app.Member.Session.pageTemplates.fetch(app.modules.ui.templates.checkout.templateId).then(function (template) {
                  if (isCordova && isCordovaReady) {
                     StatusBar.backgroundColorByHexString(app.Branding.hexModal);
                  }

                  var _checkoutDialog = ngDialog.open({
                     template: template
                     , plain: true
                     , closeByEscape: true
                     , closeByDocument: false
                     , className: "checkout"
                     , trapFocus: false
                     , data: data
                  });
                  _checkoutDialog.closePromise.then(function () {
                     if (isCordova && isCordovaReady) {
                        StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                     }
                  });
               });

            }
            , prepaid: function (data) {
               ngDialog.closeAll();

               app.Member.Session.pageTemplates.fetch(app.modules.ui.templates.prepaid.templateId).then(function (template) {
                  if (isCordova && isCordovaReady) {
                     StatusBar.backgroundColorByHexString(app.Branding.hexModal);
                  }

                  var _prepaidDialog = ngDialog.open({
                     template: template
                     , plain: true
                     , closeByEscape: true
                     , closeByDocument: false
                     , className: "prepaid"
                     , trapFocus: false
                     , data: data
                  });
                  _prepaidDialog.closePromise.then(function () {
                     if (isCordova && isCordovaReady) {
                        StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                     }
                  });
               });

            }
         }
      }


      var userAgent = function(){
         var userAgent = $window.navigator.userAgent;
         var browsers = {ipad: /iPad/i, iphone: /iPhone/i, blackberry: /Blackberry/i, android: /Android/i,  chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer/i};
         for(var key in browsers) {
            if (browsers[key].test(userAgent)) {
               return key;
               break;
            }
         }
         return 'unknown';
      };
      
      var isTouchScreen = function(){
         var rv = false;
         var ua = userAgent();
         if (ua == "ipad" || ua == "iphone" || ua == "android" || ua=="blackberry"){
            rv = true;
         }
         return rv;
      };
      
      //##//--------------------------------------- 
      
      // Public
      var service = {
         modal : modal
         , userAgent : userAgent
         , isTouchScreen : isTouchScreen
      }
      
      return service;
   }
}(angular, app));




